var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyperTextIconPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 17,
    viewBox: "0 0 101 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1555 5.85886L23.8148 0H17.1799L25.3453 11.9758V16.9572H30.9586V11.9758L39.1631 0H32.5283L28.1555 5.85886Z",
    fill: "#6C53E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8477 0H39.9609V16.9572H45.5742V13.5188H52.0417C53.7894 13.5188 59.1482 12.782 59.1482 6.5049C59.1482 0.227808 53.4477 0 51.8477 0ZM51.6698 8.52489H45.5742V4.99214H51.5737C52.3621 4.99214 53.8962 5.05087 53.8962 6.69177C53.8962 8.33268 52.5311 8.52489 51.6698 8.52489Z",
    fill: "#6C53E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4141 16.9575H79.1119V12.2537H66.0273V10.7284H78.2825V6.21326H66.0273V4.71295H79.1119V0.0126953H60.4141V16.9575Z",
    fill: "#6C53E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.536 11.9526C99.1823 11.0628 100.645 9.36848 100.645 6.22904C100.645 0.215347 94.9501 0 93.3483 0H80.9062V16.9572H86.5195V12.944H91.6238L94.4998 16.927L100.999 16.9555L97.536 11.9526ZM92.818 7.99275H86.5195V4.9512H92.7272C93.4693 4.9512 94.9163 5.00281 94.9163 6.41592C94.9163 7.82902 93.6295 7.99275 92.818 7.99275Z",
    fill: "#6C53E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64885 0.00878906H0V5.65764H5.64885V0.00878906Z",
    fill: "#6C53E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64885 11.3086H0V16.9574H5.64885V11.3086Z",
    fill: "#6C53E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64844 5.6582V11.3071H11.2973V16.9577H16.9461V11.3071V5.6582H11.2973H5.64844Z",
    fill: "#6C53E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperTextIconPurple);
export default __webpack_public_path__ + "static/media/hyper-text-icon-purple.cc83ca706341eed5c3e2e48cc84d8e3b.svg";
export { ForwardRef as ReactComponent };